<template>
<div>
    <div>
        <div class="jg-main-page">
            <div class="jg-bg">
                <img src="../assets/images/flat/pc/jg-bg.png">
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
    components: {},
    data() {
        return {
            msg: ''
        }
    },
    mounted() {

    },
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Declare.vue?e29c12e0